import { MailOutlined, PhoneOutlined, SwapOutlined } from '@ant-design/icons/lib'
import { Avatar, Space } from 'antd'
import ReportIncidentButton from 'app/components/Core/Incident/ReportButton'
import Button from 'app/components/UI-Elements/General/Button'
import { ToolBox } from 'app/lib/hooks/toolBox'
import { useCurrentContact, useCurrentCustomer } from 'app/lib/hooks/useCurrent'
import useShortViewport from 'app/lib/hooks/useShortViewport'
import useTranslation from 'app/lib/hooks/useTranslation'
import RouteService from 'app/lib/services/RouteService'

type Props = {
  showConnectButton?: boolean
}
const Support: React.FC<Props> = ({ showConnectButton }) => {
  const customer = useCurrentCustomer()
  const contact = useCurrentContact()
  const short = useShortViewport()

  const { tComponent } = useTranslation({ componentType: 'navigation', scope: 'sidebar' })
  const { getInitials } = ToolBox.useString()

  return (
    <Space direction="vertical" align="center" size={short ? 4 : 12} className="full-width support">
      <If condition={showConnectButton && contact?.has_supplier_station}>
        <div className="text-center support-switch">
          <Button
            type="secondary"
            size={short ? 'small' : 'middle'}
            href={RouteService.getKlarxConnectUrl()}
            target="_blank"
            rel="noopener noreferrer">
            <SwapOutlined />
            <span className="support-switch__label">
              {tComponent({ id: 'switch-to-klarx-connect' })}
            </span>
          </Button>
        </div>
      </If>
      <Space direction="vertical" size={short ? 2 : 8} className="support-description">
        <span className="text-bold text-primary support-title">
          {tComponent({ id: 'klarx-partner' })}
        </span>
        {/* The ways to reach them are the second line under the name, so
            the block stays three lines tall on a short screen. */}
        <Space direction="horizontal" size={8}>
          <Avatar
            size={short ? 'default' : 'large'}
            className="d-flex align-items-center"
            src={customer?.owner_image_url}>
            {getInitials(customer?.owner_name)}
          </Avatar>
          <Space direction="vertical" size={2}>
            <span className="line-height-1 support-name">{customer?.owner_name}</span>
            <Space direction="horizontal" size={4} className="support-contacts">
              <Button
                onClick={() => window.open(`tel:${customer?.owner_phone}`)}
                size={short ? 'small' : 'middle'}
                shape="circle"
                type="primary"
                danger
                icon={<PhoneOutlined />}
              />
              <Button
                onClick={() => window.open(`mailto:${customer?.owner_email}`)}
                size={short ? 'small' : 'middle'}
                shape="circle"
                type="primary"
                danger
                icon={<MailOutlined />}
              />
              <ReportIncidentButton
                iconOnly
                size={short ? 'small' : 'middle'}
                type="primary"
                danger
              />
            </Space>
          </Space>
        </Space>
      </Space>
    </Space>
  )
}

export default Support
